import React from 'react';
import { Col } from '../../../lib/utils';
import EmptyClass from './EmptyClass';
import ClassDayCard from './ClassDayCard';

const ClassHistoryThisMonth = ({ thisMonthList, searchText, thisMonthFilterList }: any) => {
    if (thisMonthFilterList && thisMonthFilterList.length === 0) {
        return (
            <Col className="w-[1192px]">
                <EmptyClass />
            </Col>
        );
    }

    return (
        <Col className="w-[1192px]" style={{ gap: 10 }}>
            {thisMonthList?.map((item: any, index: number) => {
                const keys = Object.keys(item);
                const dayObject = item[keys[0]];
                const dayTime = dayObject[0]?.startTime;
                const filteredList = searchText
                    ? dayObject.filter((e: any) => e.alias.includes(searchText))
                    : dayObject;

                if (filteredList.length === 0) return <div key={index} />;

                return (
                    <ClassDayCard
                        key={index + 'dayList'}
                        date={dayTime}
                        classes={filteredList}
                        accentIdx={index}
                    />
                );
            })}
        </Col>
    );
};

export default ClassHistoryThisMonth;
